module.exports = __webpack_public_path__ + "media/AITemplateDescriptionLoadingIcon.879d8101.webm";